import { RouteConfig } from '../../../../routing/types'

export type PathArgs = any[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'membership-billing-update',
  path: () => '/membership/billing',
  type: 'private',
}

export default ROUTE
